import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/useToast';
import Toast from '../components/Toast';
import './Inner.css';

export function Profile() {
  const { user, updateProfile } = useAuth();
  const { toasts, toast } = useToast();
  const [form, setForm]   = useState({ name: user.name, email: user.email });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const set = (k, v) => {
    setForm(f => ({ ...f, [k]: v }));
    setErrors(e => ({ ...e, [k]: '' }));
  };

  const handleProfile = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { setErrors({ name: 'Name is required.' }); return; }
    setLoading(true);
    await new Promise(r => setTimeout(r, 500));
    const initials = form.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
    updateProfile({ name: form.name, avatar: initials });
    setLoading(false);
    toast('Profile updated!', 'success');
  };

  return (
    <>
      <Toast toasts={toasts} />
      <div className="profile-page">
        <div className="container">
          {/* Header */}
          <div className="profile-header">
            <div className="profile-avatar" style={{ background: 'linear-gradient(135deg,#9747FF,#E040FB)' }}>
              {user.avatar}
            </div>
            <div>
              <h1>{user.name}</h1>
              <p className="profile-meta">
                {user.email} · <span className={`role-badge ${user.role}`}>{user.role}</span>
              </p>
              <p className="profile-since">
                Member since {new Date(user.createdAt).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
              </p>
            </div>
          </div>

          <div className="profile-grid">
            {/* Personal info */}
            <div className="profile-card">
              <h2>Personal info</h2>
              <form onSubmit={handleProfile}>
                <div className="fg">
                  <label>Full Name</label>
                  <input value={form.name} onChange={e => set('name', e.target.value)} className={errors.name ? 'error' : ''} />
                  {errors.name && <div className="field-error">{errors.name}</div>}
                </div>
                <div className="fg">
                  <label>Email address</label>
                  <input type="email" value={form.email} disabled style={{ opacity: 0.6 }} />
                  <p className="field-note">Email cannot be changed. Contact support if needed.</p>
                </div>
                <div className="fg">
                  <label>Role</label>
                  <input value={user.role} disabled style={{ opacity: 0.6, textTransform: 'capitalize' }} />
                </div>
                <button type="submit" className="btn-ink" disabled={loading}>
                  {loading ? <><span className="spinner" /> Saving…</> : 'Save changes'}
                </button>
              </form>
            </div>

            {/* Account info */}
            <div className="profile-card">
              <h2>Account info</h2>
              <div className="acc-info-rows">
                <div className="air">
                  <span>Member since</span>
                  <strong>{new Date(user.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })}</strong>
                </div>
                <div className="air">
                  <span>Account type</span>
                  <strong style={{ textTransform: 'capitalize' }}>{user.role}</strong>
                </div>
                <div className="air">
                  <span>Account ID</span>
                  <code style={{ fontSize: 11, background: 'var(--gray-100)', padding: '2px 6px', borderRadius: 4 }}>#{user.id}</code>
                </div>
              </div>
              <div className="profile-danger">
                <h3>Danger zone</h3>
                <p>Deleting your account is permanent and cannot be undone.</p>
                <button
                  className="btn-danger"
                  onClick={() => toast('Contact support to delete your account.', 'error')}
                >
                  Delete account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
